import { css } from 'styled-components';
import { COLORS } from '../../design/tokens';

const styles = {
  container: css`
    display: flex;
    flex-direction: column;
    padding-top: 8px;
    padding-bottom: 8px;
  `,
  textarea: css`
    color: ${COLORS.INPUT.TEXT}
    text-align: ${props => props.align};
    font-size: 16px;
    margin-top: 4px;
    border-color: ${COLORS.INPUT.BORDER};
    border-radius: 4px;
    outline: none;
    padding: 10px;

    ::placeholder {
      color: ${({ error }) =>
        error === 'true' ? COLORS.INPUT.ERROR.PLACEHOLDER : COLORS.GRAY_4};
    }

    &:focus {
      border-color: ${({ error }) =>
        error === 'true' ? '#e0b4b4' : COLORS.INPUT.FOCUS.BORDER};

      ::placeholder {
        color: ${({ error }) =>
          error === 'true'
            ? COLORS.INPUT.FOCUS.ERROR.PLACEHOLDER
            : COLORS.GRAY_4};
      }
    }
    &:hover {
      border-color: ${COLORS.INPUT.HOVER.BORDER};
    }

    // ERROR STYLES
    ${({ error }) =>
      error === 'true'
        ? css`
            background-color: #fff6f6;
            border-color: #e0b4b4;
            color: ${COLORS.INPUT.ERROR.TEXT};
          `
        : null}

  `,
  message: css`
    color: ${({ error }) =>
      error ? COLORS.INPUT.ERROR.TEXT : COLORS.INPUT.TEXT};
    margin-top: 6px;
  `
};

export default styles;
